export default {
    init() {
    },
    finalize() {

        $('.offers .post').each(function() {
            if($(this).find('.image').data('bg-image')) {
                $(this).find('.image').css('background-image', 'url(' + $(this).find('.image').data('bg-image') + ')');
                $(this).find('.image').removeData('bg-image');
            }
        })
        
        var offers = $('.offers .posts').children();

        filter(null, window.location.hash.replace('#', ''))

        function filter($this, hash = null) {
            $('.offers .posts').empty();
            $('.offers .posts').append(offers);
            $('.tabs .offers-filter').removeClass('active');

            var category;

            if(hash) {
                category = hash;
            } 
            else {
                if(!$this) {
                    generatePagination();
                    $('.tabs .offers-filter.all').addClass('active');
                    return;
                }

                category = $this.data('category');
                window.history.pushState('.', '', `${window.location.origin}${window.location.pathname}#${$this.data('category')}`);
            }

            $('[data-category="' + category + '"]').addClass('active');

            $('.offers .post').each(function() {
                if($(this).data('slugs').indexOf(category) === -1) {
                    $(this.remove())
                }
            })

            generatePagination();
            pageController(9, 1);
        }

        function generatePagination() {
            $('#pagination').empty();

            var extractPage = []; 
            extractPage.push(document.URL.match(/pg=([0-9]+)/)); 

            var currentPage = extractPage[0] ? +extractPage[0][1] : 1,
                itemsPerPage = 9,
                totalItems = $('.offers .post').length,
                totalPages = Math.ceil(totalItems / itemsPerPage);

            if(itemsPerPage >= totalItems) {
                return;
            }
            
            
            if(!currentPage || currentPage !== 1) {
                $('#pagination').append('<a class="item arrow" data-page="1"><i class="fal fa-chevron-left"></i></a>');
            }

            for(var i = 0; i < totalPages; i++) {
                $('#pagination').append(`<a class="item" data-page="${i + 1}">${i + 1}</a>`);
            }

            if(currentPage !== totalPages) {
                $('#pagination').append(`<a class="item arrow" data-page="${totalPages}"><i class="fal fa-chevron-right"></i></a>`);
            }

            pageController(itemsPerPage, 1);
            makeItClickable();

        }

        function pageController(itemsPerPage, currentPage) {
            $('#pagination .item:not(.arrow)').removeClass('active');
            $('#pagination .item:not(.arrow)').eq(currentPage - 1).addClass('active');

            $('.offers .post').show();

            var startItem = (itemsPerPage * currentPage) - itemsPerPage,
                lastItem = itemsPerPage * currentPage;

            $('.offers .post').each(function() {
                if(($(this).index() + 1) <= startItem || ($(this).index() + 1) > lastItem) {
                    $(this).hide();
                }
            })
        }

        var extractPage = []; 
        extractPage.push(document.URL.match(/pg=([0-9]+)/)); 

        if(extractPage[0]) {
            pageController(9, extractPage[0][1]);
        }

        function makeItClickable() {
            $('#pagination .item').click(function() {
                window.history.pushState('', '', `${window.location.origin}${window.location.pathname}?pg=${$(this).data('page')}${window.location.hash}`);

                generatePagination();

                pageController(9, $(this).data('page'));

                $(window).scrollTop(0);
            });
        }


        $('.page-id-476 .quick-links-offers .button-wrapper .button').each(function() {
            $(this).addClass('offers-filter');
            $(this).attr('data-category', $(this).attr('href'));
        })

        $('.offers-filter').click(function(e){
            e.preventDefault();
            filter($(this), false)
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/archive-offers.js